export default __webpack_public_path__ + "static/media/plain-sticker-R.a2f39e31.png";